import Cookies from 'js-cookie'

const TokenKey = process.env.VUE_APP_TOKENKEY;

export function getToken() {
  return sessionStorage.getItem(TokenKey) || localStorage.getItem(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token)
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
  return sessionStorage.removeItem(TokenKey)
}
